<template>
    <Loading>
        <div class="p-4 d-flex align-items-center">
            <Row class="toggle-row mr-3" rounded />
            <Row class="w-75" rounded />
        </div>
    </Loading>
</template>

<script>
import Loading from '~/components/skeletons/base/Loading';
import Avatar from '~/components/skeletons/base/Avatar';
import Row from '~/components/skeletons/base/Row';

export default {
    name: 'CommunicationSkeleton',
    components: { Loading, Avatar, Row },
};
</script>

<style scoped>
.toggle-row {
    border-radius: 14px;
    width: 48px;
    height: 18px;
}
</style>
